import React from 'react';
import { Button, UserAvatar } from '../common';

export const MVPVoteCard = ({
  participant,
  isSelected,
  isSelf,
  onVote,
  disabled,
  loading
}) => {
  const { displayName, avatarUrl, isGM } = participant;

  return (
    <div
      className={`
        flex items-center justify-between p-4 rounded-lg border-2 transition-all
        ${isSelected
          ? 'border-primary-500 bg-primary-50'
          : 'border-gray-200 hover:border-gray-300'}
        ${isSelf ? 'opacity-60' : ''}
      `}
    >
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <UserAvatar
          displayName={displayName}
          avatarUrl={avatarUrl}
          size="md"
          isGM={isGM}
        />

        {/* Name and role */}
        <div>
          <div className="flex items-center gap-2">
            <span className="font-medium">{displayName}</span>
            {isGM && (
              <span className="px-1.5 py-0.5 text-xs font-medium bg-purple-100 text-purple-700 rounded">
                GM
              </span>
            )}
            {isSelf && (
              <span className="px-1.5 py-0.5 text-xs font-medium bg-gray-100 text-gray-500 rounded">
                You
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Vote button */}
      <div>
        {isSelf ? (
          <span className="text-sm text-gray-400">Can't vote for self</span>
        ) : isSelected ? (
          <span className="text-sm font-medium text-primary-600">Your vote</span>
        ) : (
          <Button
            size="sm"
            variant="secondary"
            onClick={() => onVote(participant.id)}
            disabled={disabled}
            loading={loading}
          >
            Vote
          </Button>
        )}
      </div>
    </div>
  );
};
